import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getForBusinessImage } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";
import { useNavigate } from "react-router-dom";

export default function HeaderView() {
  const {id,partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [data, setHeader] = useState({
  });


  const fetchHeaderImage = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await getForBusinessImage(id);
      const headerData = res.data.data[0];
      setHeader({ ...headerData, index: res.data.data.indexOf(headerData) });
      if (headerData && headerData.id) {
        navigate(`/${partnerId}/forbusiness/headerimg/edit/${headerData.id}`);
      } 
      console.log(headerData);
    } catch (err) {
      showToast({
        type: 'error',
        message: err.response.data.message || 'Failed to fetch header image. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetchHeaderImage();
  }, [id]);

  const columns = ["Header Image", "Header Paragraph"];
  const rows = [];

  if (data && Object.keys(data).length > 0) {
    rows.push([data.paragraph, data.image ? <img src={data.image} alt="header" width="450" height="300"/> : null]);
  }
  return (
<>
{isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      <HomeTitle>Header Section</HomeTitle>
      <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
      <ButtonWrapper>
        <Link to={`/${partnerId}/forbusiness`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/forbusiness/headerimg/edit/${id}`}>
          <Button>{Number(id) ? 'Edit' : 'Add'} header section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
</>
  );
}
const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
    @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
`;
